import {
  If,
  Then,
  Else,
} from "react-if";

import { ContactTableRoot } from "../../ContactTable/ContactTableRoot";
import { Button } from "../../../../../common/Atoms/Button";
import { WrappedLink } from "../../../WrappedLink";
import { useCurrentGroup } from "../../../../hooks/useGroups";
import { Heading } from "../../../../../common/Atoms/Typography/Heading";
import { Paragraph } from "../../../../../common/Atoms/Typography/Paragraph";

export function GroupContactsWrapper() {
  const { groupFormData } = useCurrentGroup();
  const contactsCount = groupFormData?.contactsCount || 0;

  return (
    <div>
      <If condition={ contactsCount === 0 }>
        <Then>
          <div className={ `flex flex-col items-center justify-center py-12 px-4` }>
            <Heading className={ `mb-3 text-center` }>
              { `No contacts in this group yet` }
            </Heading>
            <Paragraph className={ `mb-6 text-center max-w-2xl` }
              variant={ `secondary` }>
              { `You need to add customers to this group in order to have the policies apply to them. Click the button below to select which customers you want to add to this group.` }
            </Paragraph>
            <WrappedLink
              to={ `/contacts/manage` }
            >
              <Button
                color={ `green` }
              >
                { `+ Add contacts to group` }
              </Button>
            </WrappedLink>
          </div>
        </Then>
        <Else>
          <div className={ `flex justify-end mb-0` }>
            <WrappedLink
              to={ `/contacts/manage` }
            >
              <Button
                color={ `green` }
              >
                { `+ Add contacts to group` }
              </Button>
            </WrappedLink>
          </div>
          <ContactTableRoot context={ `group` } />
        </Else>
      </If>
    </div>
  );
}
